import { Box, Button, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { UpgradeDialogSource } from "schemas/dashboard";
import { Plans } from "schemas/payments";

import styles from "./styles";

const VirtualAssistantCard = () => {
  const location = useLocation();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { setUpgradeDialogSource, setOpenCheckoutDialog } =
    useContext(SubscriptionContext);

  if (currentOrg?.isVaUser) {
    return <></>;
  }

  const checkoutVaPage = () => {
    setUpgradeDialogSource(UpgradeDialogSource.upgrade_va_button);
    setOpenCheckoutDialog({
      plan: Plans.VA_YEARLY,
      pageSource: location.pathname,
      source: UpgradeDialogSource.upgrade_va_button,
    });
  };

  return (
    <Box sx={styles.cardBg}>
      <Box sx={styles.chip}>🔒 AI Virtual Assistant</Box>
      <Typography variant="h4" sx={{ color: "yellow.main" }} gutterBottom>
        Want a Virtual Assistant to pitch for you?
      </Typography>

      <Typography sx={{ color: "#ECEAE5", mb: 2 }}>
        300 pitches sent on your behalf (+ 700 self serve emails), no manual
        work needed
      </Typography>

      <Button
        variant="outlined"
        sx={styles.upgradeButton}
        fullWidth
        onClick={checkoutVaPage}
      >
        Upgrade to unlock VA
      </Button>
    </Box>
  );
};

export default VirtualAssistantCard;
